
  (function () {
    var sectionId = "template--27450818429224__home_satisfaction_section_tmXan8";
    var modal = document.querySelector('[data-fey-review-modal="' + sectionId + '"]');
    if (!modal) return;
    document.body.appendChild(modal);

    var modelEl = modal.querySelector('[data-fey-review-modal-model]');
    var quoteEl = modal.querySelector('[data-fey-review-modal-quote]');
    var nameEl = modal.querySelector('[data-fey-review-modal-name]');
    var ctaEl = modal.querySelector('[data-fey-review-modal-cta]');

    function openModal(data) {
      modelEl.textContent = data.model || '';
      quoteEl.textContent = data.quote || '';
      nameEl.textContent = data.name || '';
      if (data.cta && data.url) {
        ctaEl.textContent = data.cta;
        ctaEl.href = data.url;
        ctaEl.hidden = false;
      } else {
        ctaEl.hidden = true;
      }
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    function closeModal() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    document.addEventListener('click', function (e) {
      var openCard = e.target.closest('[data-fey-review-open]');
      if (openCard) {
        var dataEl = openCard.querySelector('[data-fey-review-data]');
        if (dataEl) {
          try {
            openModal(JSON.parse(dataEl.textContent));
          } catch (err) {}
        }
        return;
      }
      if (e.target.closest('[data-fey-review-close]')) {
        closeModal();
        return;
      }
      var next = e.target.closest('[data-fey-reviews-next]');
      if (next) {
        var rail = next.closest('[data-fey-reviews-wrap]').querySelector('[data-fey-reviews-rail]');
        var item = rail.querySelector('.fey-reviews__item');
        var step = item ? item.getBoundingClientRect().width + 14 : rail.clientWidth * 0.8;
        rail.scrollBy({ left: step, behavior: 'smooth' });
      }
    });

    function updateAffordance() {
      document.querySelectorAll('[data-fey-reviews-wrap]').forEach(function (wrap) {
        var rail = wrap.querySelector('[data-fey-reviews-rail]');
        var nextBtn = wrap.querySelector('[data-fey-reviews-next]');
        var fadeEl = wrap.querySelector('[data-fey-reviews-fade]');
        if (!rail || !nextBtn || !fadeEl) return;
        var atEnd = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 4;
        var scrollable = rail.scrollWidth > rail.clientWidth + 4;
        nextBtn.classList.toggle('is-hidden', atEnd || !scrollable);
        fadeEl.classList.toggle('is-hidden', atEnd || !scrollable);
      });
    }
    document.addEventListener('scroll', function (e) {
      if (e.target.matches && e.target.matches('[data-fey-reviews-rail]')) updateAffordance();
    }, true);
    window.addEventListener('resize', updateAffordance);
    updateAffordance();

    /* Progress rule + arrows + drag, mirroring the product slider's rail. */
    document.querySelectorAll('[data-fey-reviews-rail]').forEach(function (rail) {
      if (rail.dataset.railBound) return;
      rail.dataset.railBound = '1';

      var row = document.createElement('div');
      row.className = 'fey-reviews__scrollbar';
      var bar = document.createElement('div');
      bar.className = 'fey-reviews__progress';
      var thumb = document.createElement('span');
      bar.appendChild(thumb);
      row.appendChild(bar);

      var CHEVRON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="POINTS"/></svg>';
      var nav = document.createElement('div');
      nav.className = 'fey-reviews__nav';
      var prev = document.createElement('button');
      prev.type = 'button';
      prev.setAttribute('aria-label', 'Prejšnje ocene');
      prev.innerHTML = CHEVRON.replace('POINTS', '15 18 9 12 15 6');
      var next = document.createElement('button');
      next.type = 'button';
      next.setAttribute('aria-label', 'Naslednje ocene');
      next.innerHTML = CHEVRON.replace('POINTS', '9 18 15 12 9 6');
      nav.appendChild(prev);
      nav.appendChild(next);
      row.appendChild(nav);
      rail.insertAdjacentElement('afterend', row);

      /* The configurator pill belongs on this row, at its right end (David
         2026-08-27: "ta button nej bo desno ne spodi"), not on a line of its
         own under the rail. The row is built here rather than in Liquid, so
         the pill -- which IS Liquid, because its href and label are section
         content -- gets moved in rather than duplicated. Desktop only: the
         phone frame keeps its own full-width CTA below the rail. */
      var section = rail.closest('.shopify-section') || document;
      var deskCta = section.querySelector('.fey-reviews__cta--desktop');
      if (deskCta) row.appendChild(deskCta);

      function step() {
        var card = rail.querySelector('.fey-reviews__item');
        if (!card) return rail.clientWidth;
        var gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
        return card.offsetWidth + gap;
      }
      var smooth = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: smooth }); });
      next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: smooth }); });

      function update() {
        var max = rail.scrollWidth - rail.clientWidth;
        var restLeft = parseFloat(getComputedStyle(rail).paddingLeft) || 0;
        prev.disabled = rail.scrollLeft <= restLeft + 1;
        next.disabled = max <= 1 || rail.scrollLeft >= max - 1;
        if (max <= 1) { row.style.display = 'none'; return; }
        row.style.display = '';
        var visible = rail.clientWidth / rail.scrollWidth;
        var travel = rail.scrollLeft / max;
        thumb.style.width = (visible * 100) + '%';
        thumb.style.transform = 'translateX(' + (travel * (100 - visible * 100) / visible) + '%)';
      }

      /* Drag to scroll. Snapping is off for the duration or the rail judders,
         and a click that ends a real drag is swallowed so letting go over a
         card does not open its review popup. */
      var dragging = false, moved = false, startX = 0, startScroll = 0;
      rail.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'touch' || e.button !== 0) return;
        dragging = true; moved = false;
        startX = e.clientX; startScroll = rail.scrollLeft;
        rail.style.scrollSnapType = 'none';
      });
      rail.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        var dx = e.clientX - startX;
        if (!moved && Math.abs(dx) > 4) {
          moved = true;
          rail.classList.add('is-dragging');
          try { rail.setPointerCapture(e.pointerId); } catch (err) {}
        }
        if (moved) { e.preventDefault(); rail.scrollLeft = startScroll - dx; }
      });
      function endDrag() {
        if (!dragging) return;
        dragging = false;
        rail.classList.remove('is-dragging');
        rail.style.scrollSnapType = '';
      }
      rail.addEventListener('pointerup', endDrag);
      rail.addEventListener('pointercancel', endDrag);
      rail.addEventListener('lostpointercapture', endDrag);
      rail.addEventListener('click', function (e) {
        if (!moved) return;
        e.preventDefault(); e.stopPropagation(); moved = false;
      }, true);
      rail.addEventListener('dragstart', function (e) { e.preventDefault(); });


      /* The progress rule is also a control, not just a readout: click
         anywhere on it to jump there, or grab it and scrub (David 2026-08-07:
         "some people like to click, some people like to drag, some people
         like to use arrows"). Desktop pointers only -- on touch the rail
         itself is the gesture and a 3px-tall target would be unhittable.

         The thumb is positioned by transform rather than left, so the maths
         maps the pointer to the SCROLLABLE range, not to the bar's full
         width: the thumb's own width represents the visible portion and can
         never travel past the end. */
      function scrubTo(clientX, smoothly) {
        var max = rail.scrollWidth - rail.clientWidth;
        if (max <= 1) return;
        var box = bar.getBoundingClientRect();
        var visible = rail.clientWidth / rail.scrollWidth;
        var travel = box.width * (1 - visible);
        if (travel <= 0) return;
        var p = (clientX - box.left - (box.width * visible) / 2) / travel;
        p = Math.min(Math.max(p, 0), 1);
        rail.scrollTo({ left: p * max, behavior: smoothly ? smooth : 'auto' });
      }
      var scrubbing = false;
      bar.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'touch') return;
        scrubbing = true;
        try { bar.setPointerCapture(e.pointerId); } catch (err) {}
        scrubTo(e.clientX, true);
        e.preventDefault();
      });
      bar.addEventListener('pointermove', function (e) {
        if (!scrubbing) return;
        scrubTo(e.clientX, false);
      });
      function endScrub() { scrubbing = false; }
      bar.addEventListener('pointerup', endScrub);
      bar.addEventListener('pointercancel', endScrub);
      bar.addEventListener('lostpointercapture', endScrub);

      rail.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  })();
